export default "skymp5-front/0fbd217f51d6575b664b736c6edfbfa1.jpg";